import { useState, useEffect } from 'react';

function useBrowser() {
  const [isFirefox, setIsFirefox] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();

    setIsFirefox(userAgent.includes('firefox'));
  }, []);

  return {
    isFirefox
  };
}

export default useBrowser;
